import React, { Fragment, useEffect, useState } from "react";
import { Row, Col, Card, Table } from "react-bootstrap";
import { Tooltip, IconButton } from "@mui/material";
import { FaRegCopy } from "react-icons/fa";
import { useSelector } from "react-redux";
import Papa from "papaparse";
import { getLevelDeposit } from "../../../services/api_function";

export const LevelUpgrade = () => {
  const itemsPerPage = 10;
  const { wallet } = useSelector((state) => state.login);
  const { walletAddress, chainId } = wallet;
  const [apiData, setApiData] = useState([]);
  const [TotalUsers, setTotalUsers] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [tooltipText, setTooltipText] = useState("Copy address");

  const handleCopy = (address) => {
    navigator.clipboard.writeText(address);
    setTooltipText("Copied!");
    setTimeout(() => setTooltipText("Copy address"), 2000);
  };

  const handleSearch = async (e) => {
    const query = e.target.value.trim().toLowerCase();
    setSearch(query);

    if (query === "") {
      setIsSearching(false);
      setFilteredData([]);
    } else {
      const results = apiData.filter((item) =>
        item.randomRefferarAddress?.toLowerCase().includes(query),
      );
      setFilteredData(results);
      setIsSearching(true);
    }

    if (currentPage !== 1) {
      setCurrentPage(1); // Reset to the first page on search
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userDetails = localStorage.getItem("adminToken");
        const token = userDetails;
        const result = await getLevelDeposit(
          currentPage,
          itemsPerPage,
          search,
          token,
        );
        console.log(result, "API Response");
        const users = result?.data?.data || [];
        setApiData(users);
        setTotalUsers(result?.data?.pagination?.total || 0);
        setTotalPages(
          Math.ceil(result?.data?.pagination?.total / itemsPerPage),
        );
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [currentPage, search]);

  const handleNextPage = () => {
    setCurrentPage((prevPage) =>
      prevPage < totalPages ? prevPage + 1 : prevPage,
    );
  };

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => (prevPage > 1 ? prevPage - 1 : prevPage));
  };

  const displayData = isSearching ? filteredData : apiData;

  return (
    <Fragment>
      <Row>
        <div className="display_end">
          <div className="input-group" style={{ maxWidth: "300px" }}>
            <input
              type="search"
              id="form1"
              className="form-control"
              placeholder="Search here..."
              onChange={handleSearch}
            />
          </div>
        </div>

        <Col lg={12}>
          <Card>
            <Card.Header>
              <Card.Title className="text-light">Deposit List</Card.Title>
            </Card.Header>
            <Card.Body>
              <Table
                responsive
                className="table table-bordered table-striped table-hover"
              >
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>User Address</th>
                    <th>Protocol</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Date & Time</th>
                  </tr>
                </thead>
                <tbody>
                  {displayData?.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="text-center">
                        No Records Found
                      </td>
                    </tr>
                  ) : (
                    displayData?.map((data, index) => (
                      <tr key={index}>
                        <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                        <td>
                          {data?.user
                            ? `${data.user.slice(0, 6)}...${data.user.slice(-4)}`
                            : ""}
                          <IconButton
                            onClick={() => handleCopy(data?.user)}
                            size="small"
                            style={{ marginLeft: 4 }}
                          >
                            <FaRegCopy />
                          </IconButton>
                        </td>

                        <td>{data?.protocol}</td>
                        {/* <td>
                          {data?.randomRefferarAddress}
                          <Tooltip title={tooltipText} arrow>
                            <IconButton onClick={() => handleCopy(data?.randomRefferarAddress)} size="small" style={{ marginLeft: 4 }}>
                              <FaRegCopy />
                            </IconButton>
                          </Tooltip>
                        </td> */}
                        <td>{data?.amount}</td>
                        <td>
                          <span className="badge bg-warning">Success</span>
                        </td>
                        <td>
                          {new Date(data?.timestamp * 1000).toLocaleDateString(
                            "en-GB",
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>

              <div
                className="text-center mb-3 col-lg-6"
                style={{ margin: "auto" }}
              >
                <div className="filter-pagination mt-3">
                  <button
                    className="previous-button btn border m-2"
                    onClick={handlePreviousPage}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>

                  <button
                    className="next-button btn btn-success pointer border m-2"
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>

                  <span>
                    Page {currentPage} of {totalPages}
                  </span>
                  <span> Total users {TotalUsers}</span>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default LevelUpgrade;
